<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="preview">
    <div class="scaler">
      <button
        class="scaler__inc"
        @mousedown="isMousePressing = true; mutateScale(scaleStep)"
        @touchstart="isMousePressing = true; mutateScale(scaleStep)"
        @mouseleave="isMousePressing = false"
        @touchend="isMousePressing = false"
        @mouseup="isMousePressing = false"
        v-html="'&plus;'"
      />
      <i-slider
        v-model="scale"
        direction="vertical"
        :min="minScale"
        :max="maxScale"
        :step="scaleStep"
      />
      <button
        class="scaler__dec"
        @mousedown="isMousePressing = true; mutateScale(-scaleStep)"
        @touchstart="isMousePressing = true; mutateScale(-scaleStep)"
        @mouseleave="isMousePressing = false"
        @touchend="isMousePressing = false"
        @mouseup="isMousePressing = false"
        v-html="'&minus;'"
      />
    </div>
    <div class="wrapper">
      <i-scale-image
        class="viewer"
        :scale.sync="scale"
        :src="tags[index].photo"
      />
      <span
        v-show="tags.length > 1"
        class="arrow left"
        @click="nextTag"
      >
        <i class="isif isif-arrow-left" />
      </span>
      <span
        v-show="tags.length > 1 "
        class="arrow right"
        @click="previousTag"
      >
        <i class="isif isif-arrow-right" />
      </span>
    </div>
  </div>
</template>

<script>
import ISlider from '@/components/ISlider'
import IScaleImage from '@/components/IScaleImage'

export default {
  components: {
    ISlider,
    IScaleImage
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      scaleStep: 0.1,
      scale: 1,
      maxScale: 5,
      minScale: 1,
      isMousePressing: false
    }
  },
  methods: {
    mutateScale (val) {
      if (this.isMousePressing === false) return
      if (this.scale >= this.maxScale && val > 0) return
      if (this.scale <= this.minScale && val < 0) return
      this.scale += val
      setTimeout(() => {
        this.mutateScale(val)
      }, 30)
    },
    nextTag () {
      let index = this.index + 1
      index = index > this.tags.length - 1 ? 0 : index
      this.$emit('update:index', index)
      this.scale = 1
    },
    previousTag () {
      let index = this.index - 1
      index = index < 0 ? this.tags.length - 1 : index
      this.$emit('update:index', index)
      this.scale = 1
    }
  }
}
</script>

<style lang="stylus" scoped>
$gray = #c1c1c1

.preview {
  display: flex
  flex-direction: column-reverse
  position: relative
}
.scaler {
  user-select: none
  display: flex
  height: 60px
  flex-direction: row-reverse
  align-items: center
  justify-content: center

  .scaler__inc, .scaler__dec {
    background-color: transparent
    font-size: 35px
    padding: 0 25px
    color: $gray
  }
}
.wrapper {
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  overflow: hidden
  flex: 1

  &:hover {
    .arrow {
      opacity: 1
    }
  }
  .viewer {
    width: 100%
    height: 100%
  }
  .arrow {
    display: inline-block
    position: absolute
    top: 50%
    font-size: 20px
    width: 30px
    height: 30px
    line-height: 30px
    margin-top: -15px
    cursor: pointer
    text-shadow: 0 0 3px #000
    opacity: 0
    transition: opacity .1s linear

    &.left {
      left: 0
    }
    &.right {
      right: 0
    }
  }
}
</style>
